import React, { useState, useEffect } from 'react';
import axios from 'axios'
import { Divider, Layout, Row, Col } from 'antd';
import { Sidebar } from './_components/Sidebar';
import { DataQuality } from './_components/DataQuality';
import CoverageTrends from './_components/CoverageTrends';
import PeerGroupAnalysis from './_components/PeerGroupAnalysis';
import { VolumeMetrics } from './_components/VolumeMetrics';
import { DataTypes } from './_components/DataTypes';
import ClientSelection  from './_components/ClientSelection'
import { BarChartOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import useDataset from '../../components/newsGraph/hooks/useDataset'

const { Content } = Layout;

const EDA_Datasets = [{
  "_id": {
    "$oid": "691e9b1d19c2885688c11524"
  },
  "name": "WiFi Router Data",
  "althub_client_id": 2999,
  "althub_dataset_id": 20,
  "active": true,
  "value": "WiFi Router Data",
  "account_uuid": "e45d1f15f49f449ebbef5e91dcd3803c",
  "source": "",
  "update": "",
  "columns": [
    {
      "name": "dns_domain",
      "value": "dns_domain",
      "description": "dns_domain"
    },
    {
      "name": "active_location_count",
      "value": "active_location_count",
      "description": "active_location_count"
    },
    {
      "name": "active_device_count",
      "value": "active_device_count",
      "description": "active_device_count"
    },
    {
      "name": "num_locations_domain_invoked_from",
      "value": "num_locations_domain_invoked_from",
      "description": "num_locations_domain_invoked_from"
    },
    {
      "name": "num_devices_domain_invoked_from",
      "value": "num_devices_domain_invoked_from",
      "description": "num_devices_domain_invoked_from"
    },
    {
      "name": "date",
      "value": "date",
      "description": "date"
    }
  ],
  "data_type": "WiFi Router Data",
  "description": "WiFi Router Data",
  "labels": [
    "#ALL#"
  ],
  "price": 2,
  "tickers": ["TVI", "ADBE", "ALL", "GOOGL","AMZN","AXP","AAPL","ADM","T","AVGO","COF","CVX","CMG","CB","C","KO","COST","COTY","CVS","DFS","EBAY","EA","EQT","EFX","EL","EXPE","XOM","META","FL","F","GPS","GM","GS","HPE","MAR","MCD","MCK","CPRI","MSFT","MSI","NFLX","NWSA","NKE","NVDA","PYPL","PEP","RL","BKNG","PVH","SIG","SBUX","SYY","TJX","UA","UNM","VFC","V","WMT","WBA","DIS","YUM","URBN","AA","AMC","ANF","BABA","BBW","BP","BTGOF","CHH","CVR","DPZ","EPC","GCO","GDDY","GHC","GOOS","LYV","MAN","NYT","QSR","RXT","SHAK","SKX","SONY","SQ","TEF","TM","TPX","TTM","W","BHF","BLKB","CAKE","CAR","CCRN","CMCSA","CMLS","CMPR","CSOD","ETSY","FOSL","GRPN","HCKT","ZD","LULU","MIDD","MTCH","ODP","PAAS","PENN","PZZA","ROKU","RYAAY","SIRI","SPNS","TSLA","TPR","QSR.TO","SAP.TO","888.L","BME.L","CPI.L","CARD.L","CINE.L","DNLM.L","FCSS.L","FGP.L","GAW.L","GOG.L","GFTU.L","GRG.L","HFD.L","HSX.L","HSV.L","HWDN.L","IGG.L","JD.L","MARS.L","MTRO.L","MAB.L","MONY.L","MCG.L","OCDO.L","OTB.L","PNN.L","PETS.L","PHNX.L","VANQ.L","RNK.L","SAGA.L","SRP.L","SSPG.L","SGC.L","SDRY.L","TALK.L","TED.L","TEP.L","TPK.L","JDW.L","SMWH.L","WIZZ.L","ADM.L","ABF.L","AV.L","BARC.L","BDEV.L","BP.L","BT-A.L","BRBY.L","CNA.L","CPG.L","DLG.L","EZJ.L","EXPN.L","HL.L","HSBA.L","IHG.L","IAG.L","ITV.L","KGF.L","LGEN.L","LLOY.L","MKS.L","MRW.L","NXT.L","PRU.L","RR.L","NWG.L","RDSA.L","IDS.L","RSA.L","SBRY.L","SVT.L","SSE.L","TSCO.L","TUI.L","ULVR.L","UU.L","VOD.L","WTB.L","DSY.JO","FSR.JO","NOBI.ST","HM-B.ST","VOLV-B.ST","AGS.BR","1038.HK","0001.HK","AGN.AS","AKZA.AS","GVNV.AS","TKWY.AS","ALV.DE","BMW.F","LHA.F","VOW.F","1113.HK","3396.HK","PNDX-B.ST","IBE.MC","QUIZ.L","FCH.L","FUTR.L","SHOE.L","MCLS.L","WINE.L","GOOD.L","CCA.AX","CFR.SW","PNDORA.CO","VP.L","SNH.JO","JPJ.L","AO.L","BWNG.L","DFS.L","GYM.L","HFG.L","PINE.L","RTN.L","TPT.L","BNC.L","FCCN.L","WRKS.L","DMGT.L","RBG.L","WOSG.L","MTC.L","NBS.L","HSS.L","SCS.L","APGN.L","BOO.L","CVSG.L","JET2.L","ECO.L","HSM.L","HRN.L","HOTC.L","JLH.L","MUL.L","MBG.DE","EOAN.DE","BOSS.DE","PUM.DE","ZAL.DE","ZO1G.DE","0973.HK","2382.HK","005380.KS","TRN.L","FER.MC","ITX.MC","MAP.MC","TEF.MC","MONC.MI","BRITANNIA.NS","AC.PA","BNP.PA","CAP.PA","EDF.PA","ELIOR.PA","ENX.PA","EUCAR.PA","OR.PA","MC.PA","PEUG.PA","VIV.PA","NESN.SW","ZURN.SW","9983.T","6501.T","8001.T","4452.T","APO","BX","DOCU","DBX","FTCHF","MQG.AX","KER.PA","7974.T","7201.T","4755.T","7453.T","6758.T","7203.T","KKR","LEVI","LBTYA","LYFT","PINS","SPOT","SFIX","CG","WW","ZM","FLTR.L","PTON","JET.L","UBER","NTCO","AXA.F","IBDRY","NSANY","AEG","NTDOY","ITOCY","ZFSVF","TCEHY","ADDYY","AGS","FRFHF","PPRUY","SDXAY","RNLSY","HLFFF","NSRGY","GTBIF","VLVLY","VIVHY","CODYY","1082.KL","DUFN.SW","C52.SI","AGL.MI","EL.PA","HMSB.F","SNH.SG","9988.HK","ABNB","PANDY","BNPQY","CFRUY","WISH","BOSSY","VINO","CKISY","MCFE","WIX.L","MOON.L","WISE.L","MMAG.L","ROO.L","UDIRF","DCK.SG","THG.L","SSREY","ITS.L","TUI1.DE","DNUT","ZVO","WBD","ENT.L","FRAS.L","PLUS.L","PARA","BN","VMUK.L","SAPIF","DCYHY","FHNGY","CKHUY","PNDXF","STHHF","RLI.BE","SOTGY","HYMTF","FRCOY","HTHIY","BZI.F","RKUNF","FANDY","MQBKY","SSU","CURY.L","LOTB.BR","LSMNF","ATO.PA","CCV.AX","SHEL","MBG.F","ADS.DE","UTDI.DE","LHA.DE","SW.PA","RNO.PA","SGO.PA","HFG.DE","RYA.IR","SPL.WA","LMN.SW","BN.TO","0113.HK","SPNS.TA","AUDAQ","ES","BBWI","XEL","BGFV","FIVN","LOGI","RILY","MVBF","MAERSK-B.CO","HLT","AVAL","H","HTHT","WH","DANH.TA","SVC","VIC.VN","BYD","RRR","SOND","ROHLTD.BO","AHUNN0000.CM","ODHN.SW","IHG","FSTA.L","EMAR.DU","1992.HK","NXI.PA","EMAAR.AE","KCHOL.IS","LEMONTREE.NS","WEB.AX","NHH.MC","0078.HK","CENTEL.BK","MEL.MC","ORIENTHOT.NS","YIT.HE","DAL.L","008770.KS","1179.HK","ALBON.PA","HGV","MGM","MTN","PLYA","0045.HK","0069.HK","MINT.BK","GHG","FTAL.TA","9722.T","4681.T","INDHOTEL.NS","EIHOTEL.NS","M04.SI","4715.KL","ABBV","INCY","MRNA","AGN","BMY","CELG","REGN","ALXN","MMM","BDX","AMCR","CSCO","LYB","COMM","DOW","GOOG","SNAP","RDDT","DRI","EWCZ","BROS","PLNT"],
  "time_lag": "",
  "website": "",
  "frequency": "Daily",
  "nowcasting": false,
  "client_name": "Test WiFi Router Data Provider"
}]

const EDADashboard = () => {
    const {Datasets} = useDataset();
    const [EDADatasets, setEDADatasets] = useState(null)
    const [activeModule, setActiveModule] = useState('Data Quality');
    const [collapsed, setcollapsed] = useState(true)
    const [SelectedProvider, setSelectedProvider] = useState(null)
    const [SelectedProviderDataset, setSelectedProviderDataset] = useState(null)
    const [loader, setloader] = useState(true)
    const [DatasetNumericColumns, setDatasetNumericColumns] = useState(null)
    const [loadDashboard, setloadDashboard] = useState(true)

    const [tickerData, settickerData] = useState(null)


    const getTickers = () => {
        axios({
          method:'GET',
          url: `/api/tickers/?provider=${SelectedProvider?.value}&dataset_id=${SelectedProviderDataset?.value}`
        }).then(res=>{
          settickerData(res.data);
          setloader(false)
        })
      }

  
    const renderActiveModule = () => {
        switch (activeModule) {
            case 'Data Quality':
                return <DataQuality SelectedProviderDataset={SelectedProviderDataset} SelectedProvider={SelectedProvider} setDatasetNumericColumns={setDatasetNumericColumns} setloader={setloader} setloadDashboard={setloadDashboard}/>;
            case 'Coverage Trends':
                return <CoverageTrends SelectedProviderDataset={SelectedProviderDataset} SelectedProvider={SelectedProvider} tickerData={tickerData}/>;
            case 'Peer Group Analysis':
                return <PeerGroupAnalysis SelectedProviderDataset={SelectedProviderDataset} SelectedProvider={SelectedProvider} DatasetNumericColumns={DatasetNumericColumns} tickerData={tickerData} />;
            case 'Volume Metrics':
                return <VolumeMetrics SelectedProviderDataset={SelectedProviderDataset} SelectedProvider={SelectedProvider} DatasetNumericColumns={DatasetNumericColumns} tickerData={tickerData}/>;
            // case 'Data Types':
            //     return <DataTypes SelectedProviderDataset={SelectedProviderDataset} SelectedProvider={SelectedProvider} tickerData={tickerData}/>;
            default:
                return <DataQuality SelectedProviderDataset={SelectedProviderDataset} SelectedProvider={SelectedProvider} />;
        }
    };


    useEffect(()=>{
        if(SelectedProvider?.value&&SelectedProviderDataset?.value){
          setActiveModule('Data Quality')
          getTickers();
        }
      },[SelectedProvider,SelectedProviderDataset])

    useEffect(()=>{
      if (Datasets) setEDADatasets({"data" : [...EDA_Datasets, ...Datasets?.data]})
    },[Datasets])
 

    return (
        <Layout style={{ height: '100vh', backgroundColor: 'var(--appBackground)', overflow: 'hidden' }}>
          {/* Header */}
          <Layout.Header
            style={{
              padding: '0px 15px',
              backgroundColor: 'var(--appBackground)',
              position: 'sticky',
              top: 0,
              zIndex: 1000,
              height: '64px', // default AntD header height
              lineHeight: '64px',
            }}
          >
            <ClientSelection
              Datasets={EDADatasets}
              setSelectedProvider={setSelectedProvider}
              SelectedProvider={SelectedProvider}
              setSelectedProviderDataset={setSelectedProviderDataset}
              SelectedProviderDataset={SelectedProviderDataset}
              setloader={setloader}
              settickerData={settickerData}
              setloadDashboard={setloadDashboard}
            />
          </Layout.Header>

          <Divider style={{ margin: '0px', borderColor: '#334155' }} />

          <Layout style={{ backgroundColor: 'var(--appBackground)' }}>
            <Layout.Sider
              collapsed={false}
              // collapsed={collapsed}
              // onCollapse={(e) => {
              //     setcollapsed(e)
              // }}
              // onMouseMove={()=>setcollapsed(false)}
              // // onMouseHover={()=>setcollapsed(false)}
              // onMouseMoveCapture={()=>setcollapsed(false)}
              // onMouseEnter={()=>setcollapsed(false)}
              // onMouseOut={()=>setcollapsed(true)}
              // onMouseLeave={()=>setcollapsed(true)}
              width="270px"
              style={{
                backgroundColor: 'var(--appBackground)',
                borderRight: '1px solid #334155',
                padding: '10px 0px',
                overflow: 'hidden', // keep sider fixed
                height: 'calc(100vh - 64px)', // subtract header height
                position: 'sticky',
                top: 64,
              }}
            >
              <Sidebar activeModule={activeModule} onModuleChange={setActiveModule} loader={loader} />
            </Layout.Sider>

            <Content
              style={{
                backgroundColor: 'var(--appBackground)',
                padding: '15px 0px 100px 0px',
                overflow: 'auto',
                height: 'calc(100vh - 64px)', // subtract header
              }}
            >
              {SelectedProvider && SelectedProviderDataset && loadDashboard? (
                <Col span={24} style={{ margin: '0px 30px' }}>
                  {renderActiveModule()}
                </Col>
              ) : (
                <div style={{ paddingTop: '23vh', zIndex: 1000, color: 'var(--textPrimary)' }}>
                  <Col span={24} style={{ display: 'flex', justifyContent: 'center', paddingTop: '50px' }}>
                    <BarChartOutlined className="welcome-icon" style={{ fontSize: '80px' }} />
                  </Col>
                  <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="h3" level={2}>
                      Welcome to Alternative Data Dashboard
                    </Typography>
                  </Col>
                  <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Typography variant="h3">
                      {
                      !EDADatasets?"Fetching Datasets... Please wait to start exploring your data."
                      :EDADatasets?.data?.length === 0?"No datasets available. Please contact admin."
                      :!loadDashboard ? "Data not available for the selected Provider and Dataset. Please choose different options."
                      :"Please select a Provider and Dataset to start exploring your data."}
                    </Typography>
                  </Col>
                </div>
              )}            
            </Content>
          </Layout>
        </Layout>
    );
};

export default EDADashboard;